import React, { useEffect, useState } from 'react'
import GenericInput from '../genericComponents/input/GenericInputComponent';
import LanguageTranslator from '../locals/LanguageTranslator';
import LineItemDetailsTab from '../components/digiVend/orders/LineItemDetailsTab';
import GenericTabsComponent from '../genericComponents/GenericTabsComponent';
import { useDispatch, useSelector } from 'react-redux';
import useCustomToast from '../hooks/useCustomToast';
import { dispatchHandler, handleApiChange, validateMobileNumber, validateNumber } from '../helper/apiHelperFunctions';
import { allowOnlyNumbers, parseJwt, scrollIntoViewIfNeeded, uptoTwoDecimalRegex } from '../helper/genericFunction';
import GenericFormComponent from '../genericComponents/forms/GenericFormComponent';
import Icons from '../assets/icons';
import dayjs from 'dayjs';
import { v4 as uuidv4 } from 'uuid';
import { getPermissionKey } from '../helper/permissions';
import { getCurrentDateFormat } from '../helper/helperTableFunctions';
import { CONFIG } from '../config';
import { GenericFormSpreadTypeComponent } from '../genericComponents/forms/GenericFormSpreadTypeComponent';
import GenericCustomButton from '../genericComponents/GenericCustomButton';
import ParentModal from '../genericComponents/ParentModal';
import FileUpload from '../genericComponents/filesUpload/FileUpload';
import writeXlsxFile from 'write-excel-file';
import readXlsxFile from 'read-excel-file';

const headersData = {
    itemInner: {
        "Default Headers": {
            itemCode: "Item Code",
            itemName: "Item Name",
            rate: "Rate",
            orderQty: "Order Qty",
            newRequestedQty: "Request Qty",
            setPendingQty: "Pending Qty",
            itemConsumedPer: "Item Consumed %"
        },
        "Custom Headers": {
            itemCode: "Item Code",
            itemName: "Item Name",
            rate: "Rate",
            orderQty: "Order Qty",
            newRequestedQty: "Request Qty",
            setPendingQty: "Pending Qty",
            itemConsumedPer: "Item Consumed %"
        }
    },
    setInner: {
        "Default Headers": {
            setBarCode: "Set Barcode",
            singleSetQty: "Single Set Qty",
            totalNoOfSet: "Total No. Of Set",
            setOrderQty: "Set Order Qty",
            newRequestedQty: "Request Qty",
            setPendingQty: "Total Pending Qty",
            setConsumedPer: "Set Consumed %"
        },
        "Custom Headers": {
            setBarCode: "Set Barcode",
            singleSetQty: "Single Set Qty",
            totalNoOfSet: "Total No. Of Set",
            setOrderQty: "Set Order Qty",
            newRequestedQty: "Request Qty",
            setPendingQty: "Total Pending Qty",
            setConsumedPer: "Set Consumed %"
        }
    }
};

function CreateShipmentWithLr(props) {

    const { vendConfig, headerKey, prevParams = {} } = props;
    const digiVendStore = useSelector(state => state.digivendStore);
    const generalStore = useSelector(state => state.generalStore);
    const dispatch = useDispatch();

    const currentDate = dayjs(new Date())

    const lrTypeList = {
        topay: "To Pay",
        toBilled: "To Be Billed",
        Paid: "Paid"
    }

    const customToast = useCustomToast();
    const [selectedData, setSelectedData] = useState(props?.selectedData)
    const [formData, setFormData] = useState({});
    const [errorData, setErrorData] = useState({})
    const [currentTab, setCurrentTab] = useState("lineItemDetails");
    const [headersType, setHeadersType] = useState("");
    // const [headersData, setHeadersData] = useState({});
    const [poDetails, setPoDetails] = useState([]);
    const [expandedSetRow, setExpandedSetRow] = useState(false);
    const [itemRowData, setItemRowData] = useState([]);
    const [poDetailsSearchValue, setPoDetailsSearchValue] = useState("");
    const [openedModal, setOpenedModal] = useState(false);
    const [uuId, setUuId] = useState("");
    const [callAutoInvoiceAmount, setCallAutoInvoiceAmount] = useState({ funCall: true })
    const [callErrroValidationFun, setcallErrroValidationFun] = useState(false);
    const [state, setState] = useState({
        mixedBoxesAllowedInThisPo: false,
        boxCreation: false,
        addSKUModal: -1,
        skuBoxesWeightWise: [],
        weightMandatory: vendConfig?.CAPTURE_WEIGHT_SKU_LEVEL,
        lbhMandatory: vendConfig?.CAPTURE_LBH_SKU_LEVEL,
        fixedTotalBoxCount: vendConfig?.FIXED_TOTAL_BOX_COUNT?.toLowerCase() === "true" ? true : false,
        mixedSKUAllowedUpto: vendConfig?.MIXED_SKU_CONFIG,
        mixedBoxesAllowed: (vendConfig?.MIXED_SKU_CONFIG == "0" || vendConfig?.MIXED_SKU_CONFIG == "") ? false : true,
        mixedSKUPerBox: vendConfig?.MIXED_SKU_PER_BOX?.toLowerCase() === "true",
        noOfSKUPerBox: {},
        emptyCartonWeight: "",
        overallRequestedQtyError: "",
        boxPrefix: "",
        boxTemplate: null,
    });
    const [isAllQtyZero, setIsAllQtyZero] = useState(vendConfig?.ZERO_QTY_ASN_FORM_INITIALISATION || true ? true : false)
    const [skuWiseBoxes, setSkuWiseBoxes] = useState({});
    const [boxes, setBoxes] = useState([])
    const [callBackFun, setCallBackFun] = useState({ funName: "", value: "" })
    const [formSettings, setFormSettings] = useState({})
    const [modalData, setModalData] = useState({})

    // state:  to store the local dropdown data here
    const [localDropdownData, setLocalDropdownData] = useState({});
    const [vehicleTypeList, setVehicleTypeList] = useState([]);
    const [transportModeDropdown, setTransportModeDropdown] = useState([]);

    // State : To store the local drafted asn data
    const [poDetailsResponse, setPoDetailsResponse] = useState(null);
    const [currentShipmentTypeData, setCurrentShipmentTypeData] = useState(null);
    const [backupShipmentTypeData, setBackupShipmentTypeData] = useState(null)

    // state to store get images data
    const [uploadedFileDirectory, setUploadedFileDirectory] = useState({});
    const [getImagesOf, setGetImagesOf] = useState("");
    const [updateImageState, setUpdateImageState] = useState(false);
    const [checkEligibleASN, setCheckEligibleASN] = useState(false);
    const [originalPoDetails, setOriginalPoDetails] = useState([]);
    const [anyPoOnHold, setAnyPoOnHold] = useState(false);
    const [isExportingExcel, setIsExportingExcel] = useState(false);

    // For LR Det
    const [storeAutoApiRes, setStoreAutoApiRes] = useState({})
    const [lrDetailList, setLrDetailList] = useState([]);

    let tokenData = parseJwt(sessionStorage.getItem("token")) || {};

    useEffect(() => {
        getAsnInfoForEdit()
        handleApiChange(dispatch, "getDropdownRequest", { type: 'VEHICLE_TYPE' })
        setTimeout(() => {
            handleApiChange(dispatch, "getDropdownRequest", { type: 'LR_TRANSPORT_TYPE' })
        }, 1000)
    }, [])

    const getAsnInfoForEdit = () => {
        const orderId = selectedData?.id || prevParams?.id || props?.selectedData?.id || "";
        const poType = selectedData?.poType || props?.selectedData?.poType || "";
        const isNonSet = isPoNonSet();
        console.log("dsfsdfsdf", isNonSet, selectedData)
        let payload = {
            detailType: isNonSet ? "item" : "set",
            orderId: orderId,
            poType: poType,
            setHeaderId: "",
            version: "v2",
            dataType: "create"
        }
        setUuId(uuidv4() + (tokenData.jti || ""));
        dispatchHandler(dispatch, "vendorpoGetPodetailRequest", payload, getPermissionKey("purchase", "shipment", "create"))
        dispatchHandler(dispatch, "vendorlogiFindLrAutoRequest", { orderId: orderId, baseUrl: CONFIG.SM_BACKEND_BASE_URL, apiUrl: "/purchase/logistics/data/auto" }, getPermissionKey("purchase", "logistic", "create"));
        let lrDetailListData = [];
        let selectedDataUpdate = { ...selectedData };
        delete selectedDataUpdate?.dueDays;
        delete selectedDataUpdate?.orderCode;
        delete selectedDataUpdate?.id;
        selectedDataUpdate["poType"] = isNonSet ? "NON-SET" : "SET";
        lrDetailListData.push({ ...selectedDataUpdate, shipmentAdviceNo: "" });
        setLrDetailList(lrDetailListData);
        getTableHeaders("db");
        setUuId(uuidv4() + (tokenData.jti || ""));
    }

    useEffect(() => {
        if (callErrroValidationFun) {
            finalSubmitValidationsCheck();
            setcallErrroValidationFun(false)
        }
    }, [callErrroValidationFun])

    useEffect(() => {
        const anyHold = originalPoDetails?.some(item => item?.isPoItemHold || item?.tnaCompleted === false);
        setAnyPoOnHold(anyHold);
    }, [originalPoDetails]);

    useEffect(() => {
        if (updateImageState) {
            setUpdateImageState(false);
        }
    }, [updateImageState])

    useEffect(() => {
        if (generalStore?.getDropdownData?.isSuccess) {
            switch (generalStore?.getDropdownData?.data?.type) {
                case "LR_TRANSPORT_TYPE": {
                    setTransportModeDropdown(generalStore?.getDropdownData?.data?.resource || []);
                    break;
                }
                case "VEHICLE_TYPE": {
                    const vehicleType = (generalStore?.getDropdownData?.data?.resource || []).map(item => ({ vehicleType: item }));
                    setVehicleTypeList(vehicleType);
                    break;
                }
            }
        }
    }, [generalStore?.getDropdownData?.isSuccess])

    useEffect(() => {
        if (generalStore?.getDocumentDownloadFilepathData?.isSuccess) {
            let obj = {
                ewbBillDoc: "lrDetails",
                invoiceDoc: "shipmentDetails"
            }
            if (getImagesOf) {
                let formDataClone = { ...formData };
                formDataClone = {
                    ...formDataClone,
                    [obj[getImagesOf]]: {
                        ...formDataClone?.[obj[getImagesOf]] || {},
                        [getImagesOf]: generalStore?.getDocumentDownloadFilepathData?.data
                    }
                }
                setFormData(formDataClone);
                setGetImagesOf("");
                setUpdateImageState(!updateImageState);
            }
        }
    }, [generalStore?.getDocumentDownloadFilepathData?.isSuccess])


    const updateStateForCreateForm = (response, type = "normal", defaultFormValues = {}) => {
        let poDetailsData = response?.poDetails

        let mixedBoxesAllowedInThisPo = false,
            id = selectedData?.poType === "poicode" ? "itemCode" : "setBarCode", boxCreation = state.boxCreation, boxPrefix = "";
        poDetailsData?.forEach(item => {
            item.id = item[id];
            item.totalAvaliableQty = item.availableQty + item.newRequestedQty;
            item.initialAvaliableQty = type === "fromAPI" ? item.availableQty + item.newRequestedQty : undefined;
            item.minQtyError = "";
            item.maxQtyError = "";

            if (isAllQtyZero) {
                item.newRequestedQty = (item?.isPoItemHold || item?.tnaCompleted === false) ? 0 : isAllQtyZero ? 0 : item.newRequestedQty;
                item.setPendingQty = (item?.isPoItemHold || item?.tnaCompleted === false) ? item.availableQty : isAllQtyZero ? item.availableQty : item?.setPendingQty;
            }
        });

        setPoDetails(poDetailsData);
        setOriginalPoDetails(poDetailsData)
        boxPrefix = response.boxPrefix;
        let poData = { ...selectedData };
        mixedBoxesAllowedInThisPo = response?.mixedSku == 1 ? true : false
        if (!mixedBoxesAllowedInThisPo && vendConfig?.ENABLE_BOX_GENERATION?.toLowerCase() === "mandatory") {
            setIsAllQtyZero(true);
        }
        poData = {
            ...poData,
            asnNo: vendConfig?.asnMask?.toLowerCase() === "true" ? response?.asnMask : response?.shipmentAdviceCodeDraft || response?.shipmentAdviceCode,
            asnFromSelectionDate: response?.asnFromSelectionDate,
            shipmentAdviceCode: response?.shipmentAdviceCode,
            asnToSelectionDate: response?.asnToSelectionDate,
            validFromSelectionDate: response?.validFromSelectionDate,
            validToSelectionDate: response?.validToSelectionDate,
            asnMask: response?.asnMask
        };
        setSelectedData(poData);
        setState({
            ...state,
            boxCreation: boxCreation,
            mixedBoxesAllowedInThisPo: mixedBoxesAllowedInThisPo,
            boxPrefix: boxPrefix,
            emptyCartonWeight: response?.emptyCartonWeight ?? "",
        });
        if (vendConfig?.VALIDATE_INV_AND_ASN_AMT.toLowerCase() === "auto" && callAutoInvoiceAmount?.funCall) {
            setCallAutoInvoiceAmount({ funCall: true, poDetailsData: poDetailsData, funName: "checkAsnAmount" });
        }

    }

    const finalSubmitValidationsCheck = () => {
        let updatedErrorData = {};
        let obj = {
            lrDetails: "Lr Details",
            shipmentDetails: "Shipment Details"
        };

        Object.keys(obj || {})?.map((mainKey) => {
            let inputFields = mainKey == "lrDetails" ? getInputFields("lrDetails") : getInputs();
            updatedErrorData[mainKey] = {};
            inputFields?.map(item => {
                updatedErrorData[item?.key] = [];
                // Mandatory condition check
                if (item?.mandatory && !formData?.[mainKey]?.[item?.key]) {
                    updatedErrorData?.[item?.key].push(`${item?.label} is a mandatory field, please provide a valid value inside input.`)
                } else if (item?.type === "number") {
                    let errorMessages = validateNumber(formData?.[mainKey]?.[item?.key] || "", "number", "number")
                    errorMessages?.length > 0 && updatedErrorData?.[item?.key].push(errorMessages);
                }
                else if (item?.type === "mobileNo" && formData?.[item?.key] && formData?.[mainKey]?.[item?.key] !== "+91") {
                    let isMobileNumberValid = validateMobileNumber(formData?.[mainKey]?.[item?.key])
                    !isMobileNumberValid && updatedErrorData?.[item?.key].push(`Please provide a valid mobile number inside ${item?.label} input field.`);
                }

                if (updatedErrorData?.[item?.key]?.length === 0) {
                    delete updatedErrorData?.[item?.key];
                }
            })
            if(Object?.keys(updatedErrorData[mainKey] || {})?.length == 0) {
                delete updatedErrorData?.[mainKey]
            }
        })
        
        setErrorData({ ...updatedErrorData });
        return Object.keys(updatedErrorData || {})?.length > 0 ? false : true
    }

    useEffect(() => {
        if (expandedSetRow) {
            let payload = {
                detailType: "item",
                orderId: selectedData?.id || prevParams?.id || props?.selectedData?.id || "",
                poType: selectedData?.poType || props?.selectedData?.poType || "",
                setHeaderId: expandedSetRow?.setHeaderId,
                dataType: 'view',
                version: ""
            }
            dispatchHandler(dispatch, "vendorpoGetPodetailRequest", payload, getPermissionKey("purchase", "shipment", "create"))
        }
    }, [expandedSetRow])

    const getTableHeaders = from => {
        switch (from) {
            case "db": {
                Object.keys(headerKey).forEach(key => {
                    handleApiChange(dispatch, "getHeadersRequest", {
                        enterpriseName: "TURNINGCLOUD",
                        displayName: headerKey[key].key,
                        basedOn: key
                    })
                });
                break;
            }
        }

    }

    useEffect(() => {
        const res = digiVendStore?.vendorpoGetPodetailData;
        if (res?.isSuccess) {
            if (!expandedSetRow) {

                let response = res?.data?.resource;

                updateStateForCreateForm(response, "fromAPI");

                setPoDetailsResponse(response);
            }
            else {
                setItemRowData(res?.data?.resource?.poDetails ? res?.data?.resource?.poDetails?.map(item => ({ ...item, id: item.itemCode })) : [])
            }
        }

        if (generalStore?.getHeadersData?.isSuccess) {
            setHeadersType(prev => ({
                ...prev,
                [generalStore?.getHeadersData.data.basedOn]: generalStore?.getHeadersData?.data?.resource?.["Custom Headers"] === undefined || Object.keys(generalStore?.getHeadersData.data.resource["Custom Headers"]).length === 0 ? "Default Headers" : "Custom Headers",
            }));
            // setHeadersData(prev => ({
            //     ...prev,
            //     [generalStore.getHeadersData.data.basedOn]: generalStore?.getHeadersData?.data?.resource
            // }))
        }

        if (digiVendStore?.vendorlogiFindLrAutoData?.isSuccess) {
            let getInitialFormData = {
                lrDetails: {}
            }, dateField = ["lrDate", "lrETADate", "invoiceDate", "aptDate", "ewbBillDate"],
                fileDirectory = { ...uploadedFileDirectory };
            const logisticsAndDeliveryDetailsArray = ["transporterName", "lrType", "otherTransporterName", "lrDate", "lrETADate", "consignmentSlip", "invoiceNumber", "invoiceDate", "address", "invoiceDoc"],
                eWayBillDocArray = ["ewbBillNo", "ewbBillDate", "ewbBillDoc"],
                otherDetails = ["consignmentNo", "courier", "transporterName", "lrWeight", "lrRate", "otherCharges", "lrFreight", "lrPcs", "lrBales", "transporterMode", "vehicleType", "vehicleNo", "declarationAmount", "consigneeName", "consignorName", "stationFrom", "stationTo", "remarks", "consignorCode"];
            let response = digiVendStore?.vendorlogiFindLrAutoData?.data?.resource || {};
            let dataKeyObj = { consignee: "consigneeName", consignor: "consignorName", fromLocation: "stationFrom", toLocation: "stationTo", lrBales: "lrBales", declarationAmount: "declarationAmount", transporter: "otherTransporterName", boxWeight: "lrWeight" };
            response && Object.keys(response)?.map((key) => {
                if (logisticsAndDeliveryDetailsArray.includes(key) && !["address"]?.includes(key)) {
                    getInitialFormData.lrDetails[key] = dateField.includes(key) ? response[key] ? dayjs(response[key], getCurrentDateFormat(response[key])) : "" : response[key] || "";
                }
                else if (eWayBillDocArray.includes(key)) {
                    getInitialFormData.lrDetails[key] = dateField.includes(key) ? response[key] ? dayjs(response[key], getCurrentDateFormat(response[key])) : "" : response[key] || ""
                }
                else if (otherDetails.includes(key)) {
                    getInitialFormData.lrDetails[key] = dateField.includes(key) ? response[key] ? dayjs(response[key], getCurrentDateFormat(response[key])) : "" : response[key] || ""
                }
            })
            getInitialFormData.lrDetails.lrDate = currentDate
            if (response?.transporterMode) {
                getInitialFormData.lrDetails.transporterMode = { transporterMode: response?.transporterMode }
            }
            if (response?.vehicleType) {
                getInitialFormData.lrDetails.vehicleType = { vehicleType: response?.vehicleType }
            }
            if (response?.lrType) {
                const lrKey = response?.lrType === "toPay" ? "topay" : response?.lrType
                getInitialFormData.lrDetails.lrType = { lrType: lrKey, value: lrTypeList[lrKey] || "" }
            }
            if (response?.transporterName && response?.transporterCode) {
                getInitialFormData.lrDetails.otherTransporterName = {
                    transporterName: response?.transporterName,
                    transporterCode: response?.transporterCode
                }
            }
            else {
                getInitialFormData.lrDetails.otherTransporterName = null
            }
            getInitialFormData.lrDetails.transporterName = response?.lrNo || ""
            getInitialFormData.lrDetails.invoiceDoc = []
            fileDirectory["ewbBillDoc"] = response?.ewbBillDoc || ""
            fileDirectory["consignmentSlip"] = response?.consignmentSlip || ""
            setUploadedFileDirectory(fileDirectory);
            setStoreAutoApiRes(response);
            setFormData(getInitialFormData);
        }

    }, [digiVendStore?.vendorpoGetPodetailData?.isSuccess, generalStore?.getHeadersData?.isSuccess, digiVendStore?.vendorlogiFindLrAutoData?.isSuccess]);

    useEffect(() => {
        if (callAutoInvoiceAmount?.funCall && callAutoInvoiceAmount?.funName === "checkAsnAmount") {
            checkAsnAmount(callAutoInvoiceAmount.poDetailsData)
            setCallAutoInvoiceAmount({ funCall: false });
        }
    }, [callAutoInvoiceAmount])

    const disabledDateFun = (date, field) => {
        const poData = selectedData;
        let disabledDate = false;
        switch (field) {
            case "shipmentRequestDate": {
                if (vendConfig?.asnFromToApplicablility?.toLowerCase() === "true") {
                    disabledDate = disabledDate || dayjs(date).isBefore(dayjs(poData.asnFromSelectionDate), "days") || dayjs(date).isBefore(dayjs(), "days") || dayjs(date).isAfter(dayjs(poData.asnToSelectionDate), "days");
                    if (poData?.isCreateASNAllowed == 1) {
                        disabledDate = disabledDate || dayjs(date).isBefore(dayjs(poData.validFromSelectionDate), "days") || dayjs(date).isBefore(dayjs(), "days") || dayjs(date).isAfter(dayjs(poData.validToSelectionDate), "days");
                    }
                }
                else {
                    disabledDate = disabledDate || dayjs(date).isBefore(dayjs(poData.validFromSelectionDate), "days") || dayjs(date).isBefore(dayjs(), "days") || dayjs(date).isAfter(dayjs(poData.validToSelectionDate), "days");
                }
                break;
            }
            case "invoiceDate": {
                disabledDate = disabledDate || date > dayjs().endOf('day')
                break;
            }
        }

        return disabledDate;
    }
    console.log("dsfsfdsdfsdfsdf", uploadedFileDirectory)
    const callApiToGetImages = (key) => {
        let fileDir = uploadedFileDirectory?.[key];
        setGetImagesOf(key)
        if (fileDir && !formData?.[key]?.length) {
            let payload = {
                disposition: "FALSE",
                fileDirectory: fileDir,
            }
            dispatchHandler(dispatch, "getDocumentDownloadFilepathRequest", payload, getPermissionKey("purchase", "shipment", "create"));
        }
    }

    const clearUploadFiles = (key) => {
        let formDataClone = JSON.parse(JSON.stringify(formData)), fileDirectory = { ...uploadedFileDirectory };
        if (formDataClone?.[key]) {
            delete formDataClone?.[key];
            setFormData(formDataClone);
        }
        delete fileDirectory?.[key];
        setUploadedFileDirectory(fileDirectory);
    }

    // Function : to get the input type
    const getInputType = (key) => {
        let mapping = {
            "LOV": "dropdown",
            "TEXT": "text"
        }
        return mapping?.[formSettings?.[key]?.["inputType"]] || ""
    }

    const getInputs = () => {
        // 0 -> key
        // 1 -> label
        // 2 -> value
        // 3 -> type
        // 4 -> isDisabled
        // 5 -> mandatory
        // 6 -> onChange
        // 7 -> inputProps
        // 8 -> iconRight
        // 9 -> clearFun
        // 10-> dateDisabled
        // 11=> customInputValue
        // 12=> onBlur
        let obj = {};

        obj = {
            "shipmentRequestDate": ["Expected Delivery", formData?.shipmentDetails?.shipmentRequestDate ? dayjs(formData?.shipmentDetails?.shipmentRequestDate, getCurrentDateFormat(formData?.shipmentDetails?.shipmentRequestDate)) : "", "date", false, false, null, null, null, null, (date) => disabledDateFun(date, 'shipmentRequestDate')],
            "invoiceNumber": ["Invoice Number", formData?.shipmentDetails?.invoiceNumber || "", "text", false, true],
            "invoiceAmount": ["Invoice Amount", formData?.shipmentDetails?.invoiceAmount || "", "decimal", (vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "auto" || false), true, null, null, null, null, null, null, (val) => handleBlur(val, "invoiceAmount")],
            "invoiceQuantity": ["Requested Qty", formData?.shipmentDetails?.invoiceQuantity || "", "decimal", (vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "auto" || false), false, null, null, null, null, null, null, (val) => handleBlur(val, "invoiceQuantity")],
            "invoiceUpload": ["Invoice Upload", formData?.shipmentDetails?.invoiceUpload || "", "upload", (false), (true), null, () => getInputProps('invoiceUpload'), false, false, false, (value) => `${(formData?.shipmentDetails?.invoiceUpload?.length == 0 || !formData?.shipmentDetails?.invoiceUpload) ? "" : `${formData?.shipmentDetails?.invoiceUpload?.length} ${formData?.shipmentDetails?.invoiceUpload?.length <= 1 || !formData?.shipmentDetails?.invoiceUpload ? "File" : "Files"}`}`],
            "invoiceDate": ["Invoice Date", formData?.shipmentDetails?.invoiceDate ? dayjs(formData?.shipmentDetails?.invoiceDate, getCurrentDateFormat(formData?.shipmentDetails?.invoiceDate)) : "", "date", (false), true, null, null, null, null, (date) => disabledDateFun(date, 'invoiceDate')]
        }

        return Object.keys(obj)?.map(key => {
            let input = obj?.[key];
            let temp = {
                key,
                label: input?.[0] || "",
                value: input?.[1] || "",
                type: input?.[2] || "text",
                isDisabled: input?.[3] || false,
                mandatory: input?.[4] || false,
                onChange: input?.[5] || false,
                iconRight: input?.[7] || false,
                genInputExtraClass: "!w-full md:!w-[20%]"
            }
            if (input?.[6]) {
                temp.inputProps = input?.[6]
            }
            if (input?.[8]) {
                temp.clearPressFunction = input?.[8]
            }
            if (input?.[9]) {
                temp.disabledDate = input?.[9]
            }
            if (input?.[10]) {
                temp.customInputValue = input?.[10]
            }
            if (input?.[11]) {
                temp.onBlur = input?.[11]
            }
            if (key == "invoiceUpload") {
                temp.callApiToGetImages = () => callApiToGetImages(key)
                if (uploadedFileDirectory?.[key] && !formData?.[key]?.length) {
                    temp["clearPressFunction"] = (data) => clearUploadFiles(key)
                    temp.customInputValue = () => "Edit Files"
                }
            }
            return temp;
        })
    }

    const handleBlur = (e, key) => {
        switch (key) {
            case "invoiceQuantity": {
                handleCheckInvoiceQty(e, 'blur', true)
            }
                break;
            case "invoiceAmount": {
                handlecheckAmount(e, 'blur', true)
            }
                break;
        }
    }

    const handlecheckAmount = (e, blur, showMessage) => {
        let value = e?.target?.value
        if ((e.key == "Enter" || blur == "blur")) {
            if (vendConfig?.VALIDATE_INV_AND_ASN_AMT === "Warn" && ((vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() !== "disable" && +(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) > 0) || checkAsnAmount(poDetails) != +value)) {
                if (vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() !== "disable" && +(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) > 0) {
                    if (showMessage) {
                        customToast({
                            title: "An Error Occured!",
                            description: `Warning : ${setInvoiceAmountRange()}`,
                            status: "error",
                        })
                    }
                } else {
                    if (showMessage) {
                        customToast({
                            title: "An Error Occured!",
                            description: `Warning : Invoice amount ${value} is not equal to ASN amount i.e. ${checkAsnAmount(poDetails)} for Requested Quantity`,
                            status: "error",
                        })
                    }
                }
            }
        }
    }

    const setInvoiceAmountRange = () => {
        let resultedCheckedAsnAmount = +showCheckAmount(poDetails);
        let inVoiceAmountRangeTolerance = 0;
        if (vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() === "percentage") {
            inVoiceAmountRangeTolerance = (resultedCheckedAsnAmount * +(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN)) / 100;
        } else {
            inVoiceAmountRangeTolerance = +(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN);
        }
        let upperLimit = +(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) && (resultedCheckedAsnAmount + inVoiceAmountRangeTolerance).toFixed(2);
        let lowerLimit = +(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) && (resultedCheckedAsnAmount - inVoiceAmountRangeTolerance).toFixed(2);
        if (upperLimit && lowerLimit && upperLimit > 0 && lowerLimit > 0 && vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() !== "disable") {
            return `Invoice amount should be in range between ${lowerLimit} - ${upperLimit}`
        } else {
            return Number(resultedCheckedAsnAmount || "") != Number(formData?.shipmentDetails?.["invoiceAmount"] || "") ? `Invoice amount is not equal to ASN amount i.e. ${resultedCheckedAsnAmount} for Requested Quantity` : ""
        }
    }

    const handleCheckInvoiceQty = (e, blur, showMessage) => {
        let value = e.target.value, poDetailsData = JSON.parse(JSON.stringify(poDetails));
        let checkQty = poDetailsData?.reduce((n, { newRequestedQty }) => n + Number(newRequestedQty), 0);
        if ((e.key == "Enter" || blur == "blur")) {
            if (vendConfig?.INVOICE_UPLOAD_AT_CREATE_ASN?.toLowerCase() === "true" && vendConfig?.VALIDATE_INV_AND_ASN_AMT === "Warn" && value != checkQty) {
                if (showMessage) {
                    customToast({
                        title: "An Error Occured!",
                        description: `Invoice Quantity is not equal i.e ${checkQty} to Requested Quantity`,
                        status: "error",
                    })
                }
            }
        }
    }

    const isPoNonSet = () => {
        return selectedData?.poType?.toLowerCase?.() == "poicode" ? true : false
    }

    const handleEligbleASN = (checked) => {
        const poData = checked
            // ? originalPoDetails.filter(item => item?.isPoItemHold !== true)
            ? originalPoDetails.filter(item => {
                if (item?.tnaCompleted !== undefined) {
                    return item?.isPoItemHold !== true && item?.tnaCompleted === true;
                }
                return item?.isPoItemHold !== true;
            })
            : originalPoDetails;
        setOriginalPoDetails(prev => prev.length > poDetails.length ? prev : poDetails);
        setPoDetails(poData);
        setCheckEligibleASN(checked);
    };

    const getSuccessRes = (data, key) => {
        let fileDirectory = { ...uploadedFileDirectory };
        fileDirectory[key] = data?.fileDirectory
        setUploadedFileDirectory(fileDirectory)
    }

    const getInputProps = (key) => {
        let commonProps = {
            viewDataType: "table-view",
            modalMainClass: "use-as-generic-dropdown",
            search: {
                placeholder: `Search...`
            },
        };
        switch (key) {
            case "getPoDetails": return ({
                ...commonProps,
                modalMainClass: "use-as-generic-dropdown",
                getListData: (response) => response?.resource?.filter((item) => item?.orderNumber !== selectedData?.orderNumber && item?.asnHoldCheck !== 1),
                api: {
                    reduxState: "generalStore",
                    apiName: "getTableComponentFifthList",
                    apiPayload: (params) => {
                        return {
                            type: 1,
                            pageNo: params.currentPage || 1,
                            search: params.currentSearch || "",
                            sortedBy: "",
                            sortedIn: "",
                            apiUrl: "/purchase/order/get/pending/order/data",
                            baseUrl: CONFIG.SM_BACKEND_BASE_URL,
                            displayName: "VENDOR_PENDING_ALL",
                            filter: {},
                            pageSize: 10,
                            status: "APPROVED"
                        }
                    },
                    getMaxPage: (states, fucntions, response) => {
                        return response?.maxPage
                    },
                    apiExtraHeaders: getPermissionKey("purchase", "orders", "view")
                },
                headerKeys: {
                    orderNumber: { value: "Order Number" }
                },
                itemKeys: {
                    // orderNumber: [(x, y, data) => <span class="mdlr-multiple-row" style={selectedData?.orderNumber == data?.orderNumber ? {backgroundColor: "red" } : {}}>{data?.orderNumber}</span>]
                    orderNumber: ["orderNumber"]
                },
            })
            case 'invoiceUpload': return ({
                labelData: {
                    header: "Upload Invoice",
                },
                multipleFileUpload: true,
                maxSize: 5,
                fileUploadActionName: "finalSubmit",
                fileKeys: ["fileName", "", "url"],
                deleteImgFromServer: deleteImgFromServer,
                updateImageState: updateImageState,
                api: {
                    reduxState: "digivendStore",
                    apiName: "uploadUtilityDocument",
                    apiPayload: (files, removedFiles) => {
                        let formData = new FormData();
                        files?.map(file => {
                            formData.append("file", file);
                        })
                        formData.append('documentId', 0)
                        formData.append('type', "INVOICE");
                        formData.append('requestId', `${uuId}-Draft1`);
                        return formData;
                    },
                    apiExtraHeaders: getPermissionKey("common", "commonFunctionality", "upload")
                },
            })
            case "udfString01": return ({
                ...commonProps,
                search: false,
                modalMainClass: "!min-h-[auto] !top-[calc(100%+4px)]",
                headerKeys: {
                    "udfString01": { value: "" }
                },
                itemKeys: { "udfString01": ["udfString01"] },
                getListData: () => (localDropdownData?.["OUT_OF_STOCK"]?.map(item => ({ "udfString01": item?.displayName }))),
            })
            case "ewbBillDoc": return ({
                labelData: {
                    header: "Upload E-Way Bill Doc",
                },
                deleteImgFromServer: deleteImgFromServer,
                getResOutside: (data) => getSuccessRes(data, key),
                updateImageState: updateImageState,
                multipleFileUpload: true,
                maxSize: 5,
                fileUploadActionName: "finalSubmit",
                fileKeys: ["fileName", "", "url"],
                api: {
                    reduxState: "digivendStore",
                    apiName: "uploadUtilityDocument",
                    apiPayload: (files, removedFiles) => {
                        let formData = new FormData();
                        files?.map(file => {
                            formData.append("file", file);
                        })
                        formData.append('documentId', 0)
                        formData.append('type', "EWAY_BILL");
                        formData.append('requestId', uuId);
                        return formData;
                    },
                    apiExtraHeaders: getPermissionKey("common", "commonFunctionality", "upload")
                },
            })
            case "otherTransporterName": return ({
                ...commonProps,
                modalMainClass: "use-as-generic-dropdown !w-[calc(100%-15px)] md:!w-auto",
                getListData: (response) => {
                    return response?.resource?.map?.((item) => { return { ...item, otherTransporterName: item?.transporterName } })
                },
                api: {
                    reduxState: "digivendStore",
                    apiName: "getAllTransporters",
                    apiPayload: (params) => {
                        return {
                            type: params.currentSearch ? 3 : 1,
                            pageNo: params.currentPage || 1,
                            search: params.currentSearch || "",
                            slCode: storeAutoApiRes?.consignorCode
                        }
                    },
                    getMaxPage: (states, fucntions, response) => {
                        return response?.maxPage
                    },
                    apiExtraHeaders: getPermissionKey("purchase", "shipment", "create"),
                },
                headerKeys: {
                    transporterCode: { value: "Transporter/Courier Co. Code" },
                    transporterName: { value: "Transporter/Courier Co. Name" },
                },
                itemKeys: {
                    transporterCode: ["transporterCode"],
                    transporterName: ["transporterName"],
                },
            })
        case "lrType": return ({
            getListData: () => ([
                { value: "To Pay", lrType: "topay" },
                { value: "To Be Billed", lrType: "toBilled" },
                { value: "Paid", lrType: "Paid" }
            ]),
            headerKeys: {
                "value": { "label": "Type" }
            },
            itemKeys: {
                "value": ["value"]
            }
        })
        case "transporterMode": return ({
            modalMainClass: '!min-h-[0]',
            getListData: () => transportModeDropdown || [],
            headerKeys: {
                "value": { "label": "Mode" }
            },
            itemKeys: {
                "value": ["value"]
            }
        })
        case "vehicleType": return ({
            getListData: () => vehicleTypeList,
            headerKeys: {
                "vehicleType": { "label": "Vehicle Type" }
            },
            itemKeys: {
                "vehicleType": ["vehicleType"]
            }
        })
        }
    }

    const checkAsnAmount = (poDetails) => {
        let totalAmount = 0, totalBaseAmount = 0;

        if (isPoNonSet()) {
            poDetails.map((item) => {
                totalBaseAmount = (item.newRequestedQty * item.rate) + ((item.gst / item.orderQty) * item.newRequestedQty)
                totalAmount = totalAmount + Number(totalBaseAmount)
            });
        } else {
            poDetails.map((item) => {
                totalBaseAmount = ((Number(item.setValue) + (Number(item?.gst || "") || 0)) * item.newRequestedQty * item.singleSetQty) / (item.setOrderQty)
                totalAmount = totalAmount + Number(totalBaseAmount)
            });
        }

        if (vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "auto") {
            let checkQty = poDetails.reduce((n, { newRequestedQty }) => n + Number(newRequestedQty), 0);
            let formDataClone = { ...formData };
            formDataClone = {
                ...formDataClone,
                shipmentDetails: {
                    ...formDataClone?.shipmentDetails || {},
                    invoiceAmount: (+totalAmount).toFixed(2),
                    invoiceQuantity: checkQty
                }
            }
            setCallBackFun({ funName: "setFormData", value: formDataClone, setcallErrroValidationFun: true })
        }
        return totalAmount.toFixed(2)
    }

    const showCheckAmount = (poDetails) => {
        let totalAmount = 0, totalBaseAmount = 0;

        if (isPoNonSet()) {
            poDetails.map((item) => {
                totalBaseAmount = (item.newRequestedQty * item.rate) + ((item.gst / item.orderQty) * item.newRequestedQty)
                totalAmount = totalAmount + Number(totalBaseAmount)
            });
        } else {
            poDetails.map((item) => {
                totalBaseAmount = ((Number(item.setValue) + (Number(item?.gst || "") || 0)) * item.newRequestedQty * item.singleSetQty) / (item.setOrderQty)
                totalAmount = totalAmount + Number(totalBaseAmount)
            });
        }
        return totalAmount?.toFixed(2)
    }

    useEffect(() => {
        if (callBackFun?.funName == "setFormData") {
            setFormData(callBackFun?.value)
            setCallBackFun({ funName: "", value: "" })
        }
    }, [callBackFun]);

    const getRowAvailableQtyBasedOnTolerancePer = (rowItem) => {
        // Destructure and extract values with defaults
        const { tolerancePercentage = 0, orderQty = 0, totalNoOfSet = 0, qtyInputType = "I", setRequestedQty = 0, totalRequestedQty = 0 } = rowItem || {};
        const checkQty = isPoNonSet() ? orderQty : totalNoOfSet, reqQty = isPoNonSet() ? totalRequestedQty : setRequestedQty
        // Calculate tolerance percentage value
        const tolPerVal = (checkQty / 100) * Number(tolerancePercentage);
        // Return final available quantity (rounded if qtyInputType is "I")
        return qtyInputType === "I" ? (checkQty + Math.round(tolPerVal)) - reqQty : (checkQty + tolPerVal) - reqQty;
    };

    const handleQtyInput = (e, qtyInputType = "I", otherDetails) => {
        const field = e?.target?.name, index = e?.target?.dataset?.index,
            value = (field === "boxWeight" && e?.target?.value.endsWith(".") && !Number.isNaN(e?.target?.value)) ? e.target.value : e.target.value;
        let result = !Number.isNaN(value) && qtyInputType ? qtyInputType === "I" ? allowOnlyNumbers(value) : uptoTwoDecimalRegex(value) : true
        if (result) {
            let poDetailsData = [...poDetails];
            switch (field) {
                case "newRequestedQty": {
                    poDetailsData[index].newRequestedQty = +value; // ensure it's a number
                    poDetailsData[index].setPendingQty = poDetailsData[index].availableQty - poDetailsData[index].newRequestedQty;

                    // Round to 2 decimals
                    poDetailsData[index].setPendingQty = parseFloat(poDetailsData[index].setPendingQty.toFixed(2));

                    // Reset newCancelledQty
                    poDetailsData[index].newCancelledQty = 0;
                    if (Number(value) > getRowAvailableQtyBasedOnTolerancePer(poDetailsData[index])) {
                        poDetailsData[index].maxQtyError = `Request Qty must not exceed ${getRowAvailableQtyBasedOnTolerancePer(poDetailsData[index])}`;
                    }
                    else poDetailsData[index].maxQtyError = "";
                    checkAsnAmount(poDetails)
                    break;
                }
                case "addLength": {
                    poDetailsData[index].length = value;
                    break;
                }
                case "addBreadth": {
                    poDetailsData[index].breadth = value;
                    break;
                }
                case "addHeight": {
                    poDetailsData[index].height = value;
                    break;
                }
                case "addWeight": {
                    poDetailsData[index].weight = value;
                    break;
                }
            }

            // Check for percentage criteria and if newRequestedQty can be 0
            let overallRequestedQty = 0, overallAvailableQty = 0, overallOrderPercentage = 0;
            poDetailsData?.forEach(item => {
                if (item.newRequestedQty > 0) {
                    overallAvailableQty += item.availableQty;
                    overallRequestedQty += +item.newRequestedQty;
                }
            });
            overallOrderPercentage = (overallRequestedQty / overallAvailableQty) * 100;
            let rowPerValue = (Number(poDetailsData?.[index]?.newRequestedQty) / poDetailsData?.[index]?.availableQty) * 100;
            if (poDetailsData?.[index]?.newRequestedQty && poDetailsData?.[index]?.consumptionConfigValue && rowPerValue < Number(poDetailsData?.[index]?.consumptionConfigValue)) {
                poDetailsData[index].minQtyError = `Request Qty must be at least ${poDetailsData?.[index]?.consumptionConfigValue}% of ${poDetailsData?.[index].availableQty}`;
            }
            else if (poDetailsData?.[index]?.consumptionConfigValue && poDetailsData[index].minQtyError) {
                poDetailsData[index].minQtyError = "";
            }

            let overallRequestedQtyError = "";
            if (vendConfig?.asnCreationFulfilmentRequired?.toLowerCase() === "true") { // Percentage criteria is applicable
                if (vendConfig?.cancelLinePendingQty?.toLowerCase() === "true") { // newRequestedQty can be 0 for some rows
                    if (overallOrderPercentage < Number(vendConfig?.asnCreationFulfilment)) {
                        overallRequestedQtyError = `Total Request Qty must be at least ${vendConfig?.asnCreationFulfilment}% of ${overallAvailableQty}`;
                    }
                    else overallRequestedQtyError = "";
                }
                // newRequestedQty cannot be 0 for any row        
                poDetailsData?.forEach(item => {
                    if (Number(item.availableQty) > 0 && Number(item?.newRequestedQty) > 0) {
                        let minRequiredPercentage = Math.max(
                            Number(item?.consumptionConfigValue || 0),
                            Number(vendConfig?.asnCreationFulfilment || 0)
                        );
                        const orderPercentage = (Number(item.newRequestedQty) / item.availableQty) * 100;
                        if (orderPercentage < minRequiredPercentage) {
                            item.minQtyError = `Request Qty must be at least ${minRequiredPercentage}% of ${item.availableQty}`;
                        }
                        else item.minQtyError = ""
                    }
                    else item.minQtyError = ""
                });
            }
            else {
                if (!overallRequestedQty) {
                    overallRequestedQtyError = "Total Request Qty cannot be 0";
                }
                else overallRequestedQtyError = "";
            }

            setPoDetails(poDetailsData)
            setOriginalPoDetails(poDetailsData)
            setState({
                ...state,
                overallRequestedQtyError: overallRequestedQtyError
            })
        }
    }

    const handleCheckInvoiceQtyBottom = (e, blur, showMessage) => {
        let value = e?.target?.value, poDetailsData = [...poDetails]
        let checkQty = poDetailsData?.reduce((n, { newRequestedQty }) => n + Number(newRequestedQty), 0);
        if ((e.key == "Enter" || blur == "blur")) {
            if (vendConfig?.INVOICE_UPLOAD_AT_CREATE_ASN?.toLowerCase() === "true" && vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "warn" && value != checkQty) {
                if (showMessage) {
                    customToast({
                        title: "An Error Occured!",
                        description: `Invoice Quantity is not equal i.e ${checkQty} to Requested Quantity`,
                        status: "error",
                    });
                }
            }
        }
    }

    const small = (str) => {
        if (str != null) {
            var str = str?.toString()
            if (str.length <= 30) {
                return false;
            }
            return true;
        }
    }

    const handleExpand = (item) => {
        if (item?.isPoItemHold || item?.tnaCompleted === false) return
        if (!digiVendStore?.vendorshipFindSrdetailData?.isLoading && !digiVendStore?.vendorpoGetPodetailData?.isLoading) {
            if (!expandedSetRow || expandedSetRow.id != item.id) {
                setExpandedSetRow(item)
                setState({ ...state })
            }
            else {
                setExpandedSetRow(false)
                setState({ ...state })
            }
        }
    }

    const formatDate = (value) => {
        if (!value) return "";

        let d = value?.$d ? dayjs(value.$d) : dayjs(value);
        // const d = dayjs.utc(value);

        if (!d.isValid()) return "";

        return d.format("YYYY-MM-DD") + "T00:00+05:30";
    };

    // Function : To provide the final submit asn payload
    const getFinalAsnPayload = (config = {}) => {

        let {
            poDetails,
            formData,
            state,
            boxes,
            skuWiseBoxes,
        } = config;
        let hopscotchSchemaEntId = ["8534", "754"];

        let changelineitems = [],
            totalRequestQty = 0,
            basicLineAmount = 0,
            basicAmount = 0,
            taxAmount = 0,
            totalCancelledQty = 0,
            totalPendingQty = 0;

        changelineitems = poDetails?.map((item) => {
            let newRequestedQty = +item.newRequestedQty
            totalRequestQty += +newRequestedQty;
            totalCancelledQty += +item.newCancelledQty;
            totalPendingQty += +item.setPendingQty;
            basicLineAmount = Math.floor(item.rate) * newRequestedQty;
            basicAmount += +basicLineAmount;
            taxAmount += Math.floor(basicLineAmount * (item.gst / 100));
            return {
                orderDetailId: item.orderDetailId,
                setHeaderId: item.setHeaderId,
                requestedQty: newRequestedQty,
                orderQty: item.totalNoOfSet === undefined ? item.orderQty : item.totalNoOfSet,
                pendingQty: item.setPendingQty,
                cancelQty: item.newCancelledQty,
                weight: +item.weight,
                breadth: +item.breadth,
                height: +item.height,
                length: +item.length,
                tolerancePercentage: item?.tolerancePercentage || "0",
                udfString01: hopscotchSchemaEntId?.includes(tokenData?.schemaEntID) ? item?.udfString01 ?? undefined : undefined,
            };
        });

        let shipmentPackingType = formData?.shipmentDetails?.shipmentPackingType?.shipmentPackingType ? formData?.shipmentDetails?.shipmentPackingType?.shipmentPackingType : "";
        let addressArray = [formData?.shipmentDetails?.address?.address, formData?.shipmentDetails?.address?.addressLine1, formData?.shipmentDetails?.address?.zipCode, formData?.shipmentDetails?.address?.shortName]
        let addressVal = formData?.shipmentDetails?.address?.addressLine1 ? addressArray?.join(",") || "" : formData?.shipmentDetails?.address?.address;
        let payload = {
            address: addressVal || "",
            basicAmount,
            contactNo: (formData?.shipmentDetails?.contactNo === "+91" ? "" : formData?.shipmentDetails?.contactNo) || "",
            contactPerson: formData?.shipmentDetails?.contactPerson || "",
            documentNumber: selectedData?.documentNumber,
            invoiceNumber: formData?.shipmentDetails?.invoiceNumber || "",
            transporterCode: formData?.shipmentDetails?.transporter?.transporterCode || "",
            invoiceAmount: formData?.shipmentDetails?.invoiceAmount || "",
            unitCount: formData?.shipmentDetails?.unitCount || "",
            dueInDays: selectedData?.dueDays || "",
            enterpriseSite: selectedData?.siteDetails || "",
            // Upload Files
            isPackagingUploaded: formData?.shipmentDetails?.packingList?.length ? "TRUE" : "FALSE",
            folderDirectoryPackaging: formData?.shipmentDetails?.packingList?.[0]?.filePath || "",
            folderDirectoryPPS: formData?.shipmentDetails?.ppsDoc?.[0]?.filePath || "",
            folderDirectoryReport: formData?.shipmentDetails?.testReport?.[0]?.filePath || "",
            folderInvoice: formData?.shipmentDetails?.invoiceUpload?.[0]?.filePath || "",
            isInvoiceUploaded: formData?.shipmentDetails?.invoiceUpload?.length ? "TRUE" : "FALSE",
            isPPSAvailable: formData?.shipmentDetails?.ppsDoc?.length ? "TRUE" : "FALSE",
            // End Of Upload Files
            isShipConfirmed: "FALSE",
            isTestReportAvailable: formData?.shipmentDetails?.testReport?.length ? "TRUE" : "FALSE",
            location: formData?.shipmentDetails?.location?.location || "",
            locationEmail: formData?.shipmentDetails?.location?.email || "",
            orderCode: selectedData?.orderCode,
            orderId: selectedData?.orderId,
            orderNumber: selectedData?.orderNumber,
            poDetails: changelineitems,
            poType: selectedData?.poType,
            qcFromDate: formatDate(formData?.shipmentDetails?.qcFromDate),
            qcToDate: formatDate(formData?.shipmentDetails?.qcToDate),
            remarks: formData?.shipmentDetails?.remarks || "",
            shipmentRequestDate: formatDate(formData?.shipmentDetails?.shipmentRequestDate),
            invoiceDate: formatDate(formData?.shipmentDetails?.invoiceDate),
            shipmentRequestOnDate: dayjs().format("YYYY-MM-DD") + "T00:00+05:30",
            shipmentTotalCancelledQty: totalCancelledQty,
            shipmentTotalRequestedQty: totalRequestQty,
            taxAmount,
            totalPendingQty: totalPendingQty,
            transporter: formData?.shipmentDetails?.transporter?.transporterName ? formData?.shipmentDetails?.transporter?.transporterName : selectedData?.transporterName,
            validFromDate: vendConfig?.asnFromToApplicablility?.toLowerCase() === "true" ? formatDate(selectedData?.asnFromSelectionDate) : formatDate(selectedData?.validFromSelectionDate),
            validToDate: vendConfig?.asnFromToApplicablility?.toLowerCase() === "true" ? formatDate(selectedData?.asnToSelectionDate) : formatDate(selectedData?.validToSelectionDate),
            vendorName: selectedData?.vendorName,
            boxPrefix: state?.boxPrefix,
            emptyCartonWeight: +state?.emptyCartonWeight,
            agentCode: formData?.shipmentDetails?.agentCode || "",
            agentName: formData?.shipmentDetails?.agentName || "",
            uuid: uuId,
            // Add the new keys for hobscotch
            // brandLabel: getInputType("brandLabel") == "text" ? formData?.shipmentDetails?.brandLabel : formData?.shipmentDetails?.brandLabel?.displayName || "",

            shipmentPackingType: shipmentPackingType || "",
            stockRediness: formData?.shipmentDetails?.stockRediness || "",
            barcodeStatus: formData?.barcodeStatus?.barcodeStatus || "",
            barcodeType: getInputType("barcodeType") == "text" ? formData?.shipmentDetails?.barcodeType || "" : formData?.shipmentDetails?.barcodeType?.barcodeType || "",
            cartonSize: formData?.shipmentDetails?.cartonSize?.cartonSize || "",
            awbNumber: formData?.shipmentDetails?.awbNumber || "",
        };

        if (state?.boxCreation) {
            const skuWiseDetails = {};
            poDetails?.forEach(item => {
                skuWiseDetails[item.id] = item;
            });

            payload.boxes = boxes?.map((item, index) => {
                let skus = [];
                Object.keys(skuWiseBoxes).forEach(key => {
                    if (skuWiseBoxes[key][index] !== null) {
                        skus.push({
                            po_details_id: skuWiseDetails?.[key]?.orderDetailId,
                            set_header_id: skuWiseDetails?.[key]?.setHeaderId,
                            qty: skuWiseBoxes?.[key]?.[index],
                        });
                    }
                });
                return {
                    box_id: index + 1,
                    box_count: item.boxCount,
                    box_weight: Number(item.boxWeight),
                    boxTemplateId: item?.boxTemplate?.box_id || "",
                    skus
                };
            });
        }

        return payload;

    }

    const getPoType = isPoNonSet() ? 'item' : 'set';
    const getHeaderKey = isPoNonSet() ? 'itemInner' : 'setInner';


    const handleChange = (seletedModal, boxCount = 1) => {
        switch (seletedModal) {
            case "udfString01": {
                let poDetailsData = [...poDetails]
                poDetailsData[boxCount.index]["udfString01"] = boxCount?.data?.udfString01
                setPoDetails(poDetailsData)
                setOriginalPoDetails(poDetailsData)
            }
                break;
            case "openMediaViewModal": {
                setOpenedModal(seletedModal);
                setModalData(boxCount);
                break;
            }
            default: {
                setOpenedModal(seletedModal);
                break;
            }
        }
    };

    const formBottomExtras = () => {
        return (
            <div className='cam-bottom-section !pl-[15px] mb-[20px] max-w-full overflow-auto'>
                <div className='cambs-top flex justify-between items-center flex-wrap gap-2'>
                    <div className='cambt-left'>
                        <GenericTabsComponent
                            tabsData={{
                                lineItemDetails: "Line Item Details",
                            }}
                            disabledTab={{
                                createBox: !state?.boxCreation
                            }}
                            current={currentTab}
                        />
                    </div>
                    <div className='cambst-right'>
                        {/* Render the upload excel option  */}
                        {!state?.boxCreation && !props?.isEdit && (
                            <GenericCustomButton
                                label="Upload ASN Excel"
                                type='default'
                                onClick={() => handleChange("uploadAsnExcel")}
                                className='mr-0 md:mr-[12px]'
                            />
                        )}
                    </div>
                </div>
                <LineItemDetailsTab
                    expandedSetRow={expandedSetRow} state={state} poDetailsSearchValue={poDetailsSearchValue} setPoDetailsSearchValue={setPoDetailsSearchValue}
                    selectedData={selectedData} headersData={headersData} headersType={headersType} getPoType={getPoType} isEdit={false} digiVendStore={digiVendStore} anyPoOnHold={anyPoOnHold}
                    poDetails={poDetails} vendConfig={vendConfig} handleQtyInput={handleQtyInput} handleCheckInvoiceQtyBottom={handleCheckInvoiceQtyBottom} small={small} handleExpand={handleExpand} hideReqQtyToggle={true}
                    itemRowData={itemRowData} getInputProps={getInputProps} handleChange={handleChange} formData={formData} tokenData={tokenData} isAllQtyZero={isAllQtyZero} getHeaderKey={getHeaderKey} checkEligibleASN={checkEligibleASN} handleEligbleASN={handleEligbleASN}
                />
            </div>
        )
    }

    const checkInvoiceAmountRange = () => {
        let resultedCheckedAsnAmount = +checkAsnAmount(poDetails);
        let inVoiceAmountRangeTolerance = 0;
        if (vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() === "percentage") {
            inVoiceAmountRangeTolerance = (resultedCheckedAsnAmount * Number(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN)) / 100;
        } else {
            inVoiceAmountRangeTolerance = Number(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN);
        }
        let upperLimit = Number(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) && (resultedCheckedAsnAmount + inVoiceAmountRangeTolerance).toFixed(2);
        let lowerLimit = Number(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) && (resultedCheckedAsnAmount - inVoiceAmountRangeTolerance).toFixed(2);
        upperLimit = +upperLimit;
        lowerLimit = +lowerLimit;
        let invoiceAmount = +formData?.shipmentDetails?.invoiceAmount;
        if (upperLimit < 0 || lowerLimit < 0 || (lowerLimit > invoiceAmount || invoiceAmount > upperLimit)) {
            customToast({
                title: "An Error Occured!",
                description: `Please Check Invoice Amount`,
                status: "error",
            })
            return false;
        }
        return true;
    }

    // Function : To check if the total requested qty of the asn is 0
    const checkZeroQtyValidation = () => {
        let totalRequestedQty = 0
        poDetails.map((item) => {
            totalRequestedQty += (item.newRequestedQty)
        });

        if (!(totalRequestedQty > 0)) {
            customToast({
                title: "An Error Occured!",
                description: `The total sum of requested qty should be greater than 0.`,
                status: "error",
            })
        }
        return totalRequestedQty > 0 ? true : false;
    }

    const checkAsnAmountValidation = () => {
        if (vendConfig?.INVOICE_UPLOAD_AT_CREATE_ASN?.toLowerCase() === "true" && vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "restrict") {
            if (vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() !== "disable" && Number(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) > 0) {
                return checkInvoiceAmountRange();
            }
            else if (Number(formData?.shipmentDetails?.invoiceAmount) != checkAsnAmount(poDetails)) {
                customToast({
                    title: "An Error Occured!",
                    description: `Please Check Invoice Amount`,
                    status: "error",
                })
                return false
            }
            else return true
        }
        else return true;
    }

    const checkBoxQtyValidation = () => {

        if (state?.boxCreation) {
            let totalRequestedQty = poDetails.reduce((n, { newRequestedQty }) => n + Number(newRequestedQty || ""), 0);

            let totalBoxQty = 0;
            // Check for the total of the box quantity
            boxes?.map((item, index) => {
                let perBoxQty = 0;
                Object.values(skuWiseBoxes).forEach(value => {
                    if (value[index] !== null) {
                        perBoxQty += Number(value[index])
                    }
                });
                totalBoxQty += perBoxQty * item.boxCount
            })
            if (totalBoxQty != totalRequestedQty) {
                customToast({
                    title: "Box quantity validation error!",
                    description: `Boxes Quantity Sum i.e ${totalBoxQty} is not equal to Requested Quantity i.e ${totalRequestedQty}`,
                    status: "error",
                })
                return false
            }
        }
        return true;
    }

    const checkInvoiceQtyValidation = () => {
        if (vendConfig?.INVOICE_UPLOAD_AT_CREATE_ASN?.toLowerCase() === "true" && vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() === "restrict") {
            let totalRequestedQty = poDetails.reduce((n, { newRequestedQty }) => n + Number(newRequestedQty), 0);

            let totalBoxQty = 0;
            // Check for the total of the box quantity
            boxes?.map((item, index) => {
                let perBoxQty = 0;
                Object.values(skuWiseBoxes).forEach(value => {
                    if (value[index] !== null) {
                        perBoxQty += Number(value[index])
                    }
                });
                totalBoxQty += perBoxQty * item.boxCount
            })
            if (Number(formData?.shipmentDetails?.invoiceQuantity) != poDetails.reduce((n, { newRequestedQty }) => n + Number(newRequestedQty), 0)) {

                customToast({
                    title: "Invoice quantity validation error!",
                    description: `Invoice Quantity is not equal i.e ${totalRequestedQty} to Requested Quantity`,
                    status: "error",
                })
                return false
            }
            else return true
        }
        else return true
    }

    const boxsQtyError = () => {
        let result = boxes.map((item, index) => {
            let perBoxQty = 0;
            Object.values(skuWiseBoxes).forEach(value => {
                if (value[index] !== null) {
                    perBoxQty += Number(value[index])
                }
            });
            return perBoxQty
        });
        return result.some(item => item <= 0);
    }

    const checkBoxCreationError = () => {
        if (state?.boxCreation) {
            if (boxes?.length === 0) {
                customToast({
                    title: "An Error Occured!",
                    description: `Please Add Boxes`,
                    status: "error",
                })
                return false
            }
            else if (boxes?.some(item => item.boxWeight == 0)) {
                customToast({
                    title: "An Error Occured!",
                    description: `Please Check Boxes Weight`,
                    status: "error",
                })
                return false
            }
            else if (boxsQtyError()) {
                customToast({
                    title: "An Error Occured!",
                    description: `Please Check Boxes Qty`,
                    status: "error",
                })
                return false
            }
            else return true
        }
        else return true
    }

    const checkRemainingChecks = () => {
        let newIndex = poDetails.findIndex(item => item.minQtyError !== "" || item.maxQtyError !== "")
        let boxCountErrorIndex = boxes?.findIndex(item => item?.boxCountError);

        if (newIndex != -1) {
            customToast({
                title: "An Error Occured!",
                description: `Please Check Qty Error`,
                status: "error",
            })

            setCurrentTab("lineItemDetails")
            setTimeout(() => {
                scrollIntoViewIfNeeded(document.getElementById(`asnLineRow${newIndex}`));
            }, 100)
            return false
        }
        else if (boxCountErrorIndex != -1) {
            customToast({
                title: "An Error Occured!",
                description: `Please check box quantities.`,
                status: "error",
            })

            setCurrentTab("createBox")
            setTimeout(() => {
                scrollIntoViewIfNeeded(document.getElementById(`boxLineRow${newIndex}`));
            }, 100)
            return false
        }
        else return true
    }

    // Function to check if LBH and Weight are mandatory for a given item
    const isLBHWeightMandatory = (item, weightMandatory, lbhMandatory) => {
        const { newRequestedQty, length, breadth, height, weight } = item;

        if (!newRequestedQty || +(newRequestedQty) === 0) {
            return false;
        }

        if (weightMandatory === "Mandatory" && (weight === undefined || weight === null || weight === "")) {
            return true;
        }

        if (lbhMandatory === "Mandatory" && (!length || !breadth || !height)) {
            return true;
        }

        return false;
    };

    const handleSubmit = (trigger, data) => {
        // Main logic simplified using the isLBHWeightMandatory function
        const checkMandateLBWH = poDetails?.map(item => isLBHWeightMandatory(item, state?.weightMandatory, state?.lbhMandatory));
        let LBHWeightDisable = true;
        checkMandateLBWH.forEach((isMandatory, index) => {
            if (isMandatory && (poDetails?.[index]?.newRequestedQty !== "" || poDetails?.[index]?.newRequestedQty !== undefined || poDetails?.[index]?.newRequestedQty !== null || +(poDetails?.[index]?.newRequestedQty) !== 0)) {
                LBHWeightDisable = false;
            }
        });

        if (LBHWeightDisable === false) {
            customToast({
                title: "An Error Occured!",
                description: `Please Check Line Item Details and fill All the Mandatory Details.`,
                status: "error",
            })
        }

        if (finalSubmitValidationsCheck() && checkAsnAmountValidation() && checkInvoiceQtyValidation() && checkBoxQtyValidation?.() && checkBoxCreationError() && checkRemainingChecks() && LBHWeightDisable && checkZeroQtyValidation?.()) {

            let payload = getFinalAsnPayload({
                poDetails,
                formData,
                state,
                boxes,
                skuWiseBoxes,
            })

            let lrDetailListData = [...lrDetailList]
            let lrDetailPayload = []
            for (let i = 0; i < lrDetailListData.length; i++) {
                let data = {
                    saId: lrDetailListData[i].id || "",
                    saTotalQty: lrDetailListData[i].totalRequestedQty,
                    saTotalAmount: lrDetailListData[i].basicAmount,
                    dueDays: lrDetailListData[i].dueDays,
                    remarks: lrDetailListData[i].remarks,
                    shipmentAdviceNo: lrDetailListData[i].shipmentAdviceNo,
                    orderDate: lrDetailListData?.[i]?.poDate ? dayjs(lrDetailListData?.[i]?.poDate, getCurrentDateFormat(lrDetailListData?.[i]?.poDate)).format("YYYY-MM-DDT00:00:00+05:30") : "",
                    validFromDate: lrDetailListData?.[i]?.validFromDate ? dayjs(lrDetailListData?.[i]?.validFromDate, getCurrentDateFormat(lrDetailListData?.[i]?.validFromDate)).format("YYYY-MM-DDT00:00:00+05:30") : "",
                    validToDate: lrDetailListData?.[i]?.validToDate? dayjs(lrDetailListData?.[i]?.validToDate, getCurrentDateFormat(lrDetailListData?.[i]?.validToDate)).format("YYYY-MM-DDT00:00:00+05:30") : "",
                    shipmentAdviceDate: lrDetailListData?.[i]?.shipmentSelectionDate ? dayjs(lrDetailListData?.[i]?.shipmentSelectionDate, getCurrentDateFormat(lrDetailListData?.[i]?.shipmentSelectionDate)).format("YYYY-MM-DDT00:00:00+05:30"): "",
                    orderCode: lrDetailListData[i].orderCode,
                    orderNo: lrDetailListData[i].orderNumber,
                    orderId: lrDetailListData[i].orderId,
                    documentNumber: lrDetailListData[i].documentNumber,
                    poType: lrDetailListData[i].poType,
                }
                lrDetailPayload.push(data)
            }

            let finalPayload = [
                {
                    ...payload,
                    requestId: `${uuId}-Draft1`, 
                    lrNode: {
                        ewbBillNo: formData?.lrDetails?.ewbBillNo || "",
                        ewbBillDate: formData?.lrDetails?.ewbBillDate ? dayjs(formData?.lrDetails?.ewbBillDate)?.format("YYYY-MM-DD") + "T00:00:00+05:30" : "",
                        ewbBillDoc: uploadedFileDirectory?.ewbBillDoc || "",
                        logisticDate: dayjs(currentDate)?.format("YYYY-MM-DD") + "T00:00:00+05:30",
                        lrNo: formData?.lrDetails?.transporterName || "",
                        lrDate: formData?.lrDetails?.lrDate ? dayjs(formData?.lrDetails?.lrDate)?.format("YYYY-MM-DD") + "T00:00:00+05:30" : "",
                        transporterCode: formData?.lrDetails?.otherTransporterName?.transporterCode || "",
                        transporterName: formData?.lrDetails?.otherTransporterName?.transporterName || "",
                        otherTransporterName: formData?.lrDetails?.otherTransporterName?.transporterName || "",
                        lrPcs: formData?.lrDetails?.lrPcs || "",
                        lrBales: formData?.lrDetails?.lrBales || "",
                        lrWeight: formData?.lrDetails?.lrWeight || "",
                        lrType: formData?.lrDetails?.lrType?.lrType || "",
                        lrRate: formData?.lrDetails?.lrRate || "",
                        lrFreight: formData?.lrDetails?.lrFreight?.toString() || "",
                        permitNo: storeAutoApiRes?.permitNo || "",
                        policyNo: storeAutoApiRes?.policyNo || "",
                        declarationAmount: formData?.lrDetails?.declarationAmount || "",
                        consignorName: formData?.lrDetails?.consignorName || "",
                        consignorCode: formData?.lrDetails?.consignorCode || "",
                        consigneeName: formData?.lrDetails?.consigneeName || "",
                        stationFrom: formData?.lrDetails?.stationFrom || "",
                        stationTo: formData?.lrDetails?.stationTo || "",
                        vehicleNo: formData?.lrDetails?.vehicleNo || "",
                        vehicleType: formData?.lrDetails?.vehicleType?.vehicleType || "",
                        remarks: formData?.lrDetails?.remarks || "",
                        transporterMode: formData?.lrDetails?.transporterMode?.transporterMode || "",
                        lrDetailList: lrDetailPayload,
                        courier: formData?.lrDetails?.courier || "",
                        consignmentNo: formData?.lrDetails?.consignmentNo || "",
                        ownerSite: formData?.lrDetails?.stationTo || "",
                        lrETADate: formData?.lrDetails?.lrETADate ? dayjs(formData?.lrDetails?.lrETADate)?.format("YYYY-MM-DD") + "T00:00:00+05:30" : "",
                        vaShortName: formData?.lrDetails?.address?.shortName || "",
                        vaAddress: formData?.lrDetails?.address?.address || "",
                        vaCity: formData?.lrDetails?.address?.city || "",
                        vaState: formData?.lrDetails?.address?.state || "",
                        vaAddressLine1: formData?.lrDetails?.address?.addressLine1 || "",
                        vaZipCode: formData?.lrDetails?.address?.zipCode || "",
                        vaContactPerson: formData?.lrDetails?.address?.contactPerson || "",
                        vaContactNumber: formData?.lrDetails?.address?.contactNumber || "",
                        vaEmail: formData?.lrDetails?.address?.email || "",
                        consignmentSlip: uploadedFileDirectory?.consignmentSlip || "",
                        invoiceDoc: uploadedFileDirectory?.invoiceDoc || "",
                        agentCode: storeAutoApiRes?.agentCode || "",
                        agentName: storeAutoApiRes?.agentName || "",
                        otherCharges: formData?.lrDetails?.otherCharges?.toString() || "",
                        invoiceDate: formData?.lrDetails?.invoiceDate ? dayjs(formData?.lrDetails?.invoiceDate)?.format("YYYY-MM-DD") : "",
                        invoiceNumber: formData?.lrDetails?.invoiceNumber || "",
                        logisticDraftNo: storeAutoApiRes?.logisticDraftNo,
                        distance: false
                    }
                }
            ]
            dispatchHandler(dispatch, "createShipmentWithLrRequest", finalPayload, getPermissionKey("purchase", "shipment", "create"))
        }
    }

    const deleteImgFromServer = (files) => {
        let payload = [];
        files?.map((file) => {
            let fileObj = {
                fileName: file?.fileName,
                filePath: file?.filePath,
                id: file?.id
            }
            payload.push(fileObj);
        });
        dispatchHandler(dispatch, "utilityDocumentDeleteRequest", payload, getPermissionKey("purchase", "shipment", "create"));
    }

    const disabledDate = (key, current) => {
        switch (key) {
            case "lrDate": return current && current > dayjs().endOf('day');
            case "invoiceDate": {
                if (current && current > currentDate.startOf('day')) {
                    return true;
                }
                return false;
            }
            default: return
        }
    }

    const getInputFields = (type) => {
        switch (type) {
            default: {
                let inputFields = [];
                const filteredItems = [
                    {
                        "key": "transporterName",
                        "mandatory": 1,
                        "label": "LR Number./Consignment Number",
                        "type": "text",
                        "isDisabled": false
                    },
                    {
                        "key": "lrDate",
                        "mandatory": 1,
                        "label": "LR Date",
                        "type": "date",
                        "isDisabled": false
                    },
                    {
                        "key": "otherTransporterName",
                        "mandatory": 0,
                        "label": "Transporter",
                        "type": "dropdown",
                        "isDisabled": false
                    },
                    {
                        "key": "lrBales",
                        "mandatory": 1,
                        "label": "No. Of Cartons",
                        "type": "number",
                        "isDisabled": false
                    },
                    {
                        "key": "transporterMode",
                        "mandatory": 0,
                        "label": "Mode of Transport",
                        "type": "dropdown",
                        "isDisabled": false
                    },
                    {
                        "key": "vehicleType",
                        "mandatory": 0,
                        "label": "Vehicle Type",
                        "type": "dropdown",
                        "isDisabled": formData?.lrDetails?.transporterMode?.transporterMode !== "Road"
                    },
                    {
                        "key": "vehicleNo",
                        "mandatory": 0,
                        "label": "Vehicle Number",
                        "type": "text",
                        "isDisabled": formData?.lrDetails?.transporterMode?.transporterMode !== "Road"
                    },
                    {
                        "key": "consignmentNo",
                        "mandatory": (formData?.lrDetails?.transporterMode?.transporterMode && formData?.lrDetails?.transporterMode?.transporterMode !== "Road") ? 1 : 0,
                        "label": "Consignment No",
                        "type": "text",
                        "isDisabled": !formData?.lrDetails?.transporterMode?.transporterMode || formData?.lrDetails?.transporterMode?.transporterMode === "Road"
                    },
                    {
                        "key": "courier",
                        "mandatory": (formData?.lrDetails?.transporterMode?.transporterMode && formData?.lrDetails?.transporterMode?.transporterMode !== "Road") ? 1 : 0,
                        "label": "Courier",
                        "type": "text",
                        "isDisabled": !formData?.lrDetails?.transporterMode?.transporterMode || formData?.lrDetails?.transporterMode?.transporterMode === "Road"
                    },
                    {
                        "key": "ewbBillNo",
                        "mandatory": "",
                        "label": "E-Way Bill Number",
                        "type": "text",
                        "isDisabled": false
                    },
                    {
                        "key": "ewbBillDate",
                        "mandatory": "",
                        "label": "E-Way Bill Date",
                        "type": "date",
                        "isDisabled": false
                    },
                    {
                        "key": "ewbBillDoc",
                        "mandatory": "",
                        "label": "E-Way Bill Doc",
                        "type": "upload",
                        "isDisabled": false
                    }
                ];

                filteredItems?.map((item) => {
                    let obj = {};
                    obj = {
                        key: item?.key,
                        label: item?.label,
                        type: item?.type === "number" ? "decimal" : item?.type,
                        isDisabled: item?.isDisabled,
                        mandatory: item?.mandatory,
                        value: formData?.[type]?.[item.key] == 0 ? "0" : formData?.[type]?.[item.key] || "",
                        // validationFunction: (val) => validationsCheck(item?.key, val),
                        iconRight: item?.type == "dropdown" ? <Icons.GlobalSearchIcon /> : null,
                        genInputExtraClass: "!w-full md:!w-[20%]"
                    }

                    if (item?.type == "dropdown" || item.type == "upload") {
                        obj["inputProps"] = () => getInputProps(item?.key)
                    }
                    if (item.type == "upload") {
                        obj["mandatory"] = uploadedFileDirectory?.[item?.key] ? false : obj?.mandatory
                        obj["labelRightComponent"] = (uploadedFileDirectory?.[item?.key] && item?.mandatory) ? () => {
                            return (<span className="mandatory">*</span>)
                        } : null
                        obj["clearPressFunction"] = () => clearUploadFiles(item?.key)
                        obj["callApiToGetImages"] = () => callApiToGetImages(item?.key)
                        obj["customInputValue"] = () => `${(uploadedFileDirectory?.[item?.key] && formData?.[type]?.[item?.key]?.length == 0) ? "Edit Files" : (formData?.[type]?.[item?.key]?.length == 0 || !formData?.[type]?.[item?.key]) ? "Attach File" : `${formData?.[type]?.[item?.key]?.length} ${formData?.[type]?.[item?.key]?.length <= 1 || !formData?.[type]?.[item?.key] ? "File" : "Files"}`}`
                    }
                    if (item.type == "date") {
                        obj["disabledDate"] = (date) => disabledDate(item.key, date)
                    }
                    if (item.key === "lrType") {
                        obj.customInputValue = () => lrTypeList?.[formData?.lrDetails?.lrType?.lrType] || ""
                    }
                    if (item.key === "transporterMode") {
                        obj.customInputValue = () => formData?.lrDetails?.transporterMode?.value || formData?.lrDetails?.transporterMode?.transporterMode || ""
                        obj["onChange"] = (data, prevValue) => ({
                            ...prevValue,
                            vehicleType: null,
                            vehicleNo: null,
                            consignmentNo: null,
                            courier: null
                        })
                    }
                    inputFields.push(obj);
                })
                return inputFields;
            }
        }
    }

    const getActiveHeaders = () => {
        let childKey = isPoNonSet() ? "itemInner" : "setInner";
        return headersData?.[childKey]?.["Default Headers"] || headersData?.itemInner?.["Default Headers"] || {};
    };

    const exportExcelForThisPo = async () => {
        if (isExportingExcel) return;
        setIsExportingExcel(true);
        try {
            let headersObject = getActiveHeaders();
            const dataToExport = (poDetails && poDetails.length > 0)
                ? poDetails
                : (originalPoDetails && originalPoDetails.length > 0)
                    ? originalPoDetails
                    : (digiVendStore?.vendorpoGetPodetailData?.data?.resource?.poDetails || []);

            if (!dataToExport || dataToExport.length === 0) {
                customToast({
                    title: "Export Warning",
                    description: "No line items available to export yet. Please wait for PO details to load.",
                    status: "warning",
                });
                return;
            }

            let schema = Object.keys(headersObject).map(key => ({
                column: String(headersObject[key] || key),
                type: String,
                value: item => {
                    if (!item) return "";
                    if (key === "newRequestedQty") {
                        return item[key] !== undefined && item[key] !== null && item[key] !== "" ? String(item[key]) : "0";
                    }
                    let val = item[key];
                    if (val === undefined || val === null) {
                        return "";
                    }
                    if (typeof val === "object") {
                        return JSON.stringify(val);
                    }
                    return String(val);
                }
            }));

            const orderNum = selectedData?.orderNumber || selectedData?.orderNo || selectedData?.code || prevParams?.code || 'Sample';
            const sanitizedOrderNum = String(orderNum).replace(/[/\\?%*:|"<>]/g, '_');
            const fileName = `ASN_Excel_${sanitizedOrderNum}.xlsx`;

            // ✅ Pass fileName directly: write-excel-file handles cross-browser downloads on Mac/Safari/Windows
            await writeXlsxFile(dataToExport, { schema, fileName });

            customToast({
                title: "Download Started",
                description: "ASN Excel file downloaded successfully.",
                status: "success",
            });
        } catch (e) {
            console.error("Export Error, trying CSV fallback", e);
            try {
                const dataToExport = (poDetails && poDetails.length > 0)
                    ? poDetails
                    : (originalPoDetails && originalPoDetails.length > 0)
                        ? originalPoDetails
                        : (digiVendStore?.vendorpoGetPodetailData?.data?.resource?.poDetails || []);

                let headersObject = getActiveHeaders();
                let headerKeys = Object.keys(headersObject);
                let csvRows = [];
                csvRows.push(headerKeys.map(k => `"${String(headersObject[k] || k).replace(/"/g, '""')}"`).join(","));

                dataToExport.forEach(item => {
                    let row = headerKeys.map(k => {
                        let val = k === "newRequestedQty" ? (item[k] !== undefined && item[k] !== null && item[k] !== "" ? item[k] : "0") : (item[k] ?? "");
                        return `"${String(val).replace(/"/g, '""')}"`;
                    });
                    csvRows.push(row.join(","));
                });

                const orderNum = selectedData?.orderNumber || selectedData?.orderNo || selectedData?.code || prevParams?.code || 'Sample';
                const sanitizedOrderNum = String(orderNum).replace(/[/\\?%*:|"<>]/g, '_');
                const csvFileName = `ASN_Excel_${sanitizedOrderNum}.csv`;

                const csvContent = "\uFEFF" + csvRows.join("\r\n");
                const csvBlob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });

                if (window.navigator && window.navigator.msSaveOrOpenBlob) {
                    window.navigator.msSaveOrOpenBlob(csvBlob, csvFileName);
                } else {
                    const csvUrl = window.URL.createObjectURL(csvBlob);
                    const link = document.createElement('a');
                    link.href = csvUrl;
                    link.download = csvFileName;
                    link.rel = 'noopener';
                    document.body.appendChild(link);
                    link.dispatchEvent(new MouseEvent('click', { bubbles: true, cancelable: true, view: window }));
                    setTimeout(() => {
                        try {
                            document.body.removeChild(link);
                            window.URL.revokeObjectURL(csvUrl);
                        } catch (err) {}
                    }, 40000);
                }

                customToast({
                    title: "Download Started",
                    description: "ASN file downloaded successfully.",
                    status: "success",
                });
            } catch (fallbackErr) {
                console.error("Fallback Error", fallbackErr);
                customToast({
                    title: "Export Error",
                    description: e?.message || "Failed to export Excel file. Please try again.",
                    status: "error",
                });
            }
        } finally {
            setIsExportingExcel(false);
        }
    };

    const uploadAsnExcel = async (config = {}) => {
        let { file } = config;
        if (file) {
            try {
                const rows = await readXlsxFile(file);
                if (!rows || rows.length < 2) {
                    customToast({
                        title: "Excel File Error",
                        description: "The uploaded file does not contain any data rows.",
                        status: "error",
                    });
                    return;
                }

                let excelHeaders = rows[0] || [];
                let dataRows = rows.slice(1);
                
                let headersObject = getActiveHeaders();
                
                // Map Excel column index to data key
                let colIndexToKey = {};
                excelHeaders.forEach((headerText, index) => {
                    if (headerText === undefined || headerText === null) return;
                    let normHeader = String(headerText).trim().toLowerCase();
                    
                    // 1. Match against current dynamic headers
                    let matchedKey = Object.keys(headersObject).find(
                        k => String(headersObject[k]).trim().toLowerCase() === normHeader || k.toLowerCase() === normHeader
                    );

                    // 2. Common fallback aliases
                    if (!matchedKey) {
                        if (normHeader.includes("request qty") || normHeader.includes("requested qty") || normHeader === "req qty") {
                            matchedKey = "newRequestedQty";
                        } else if (normHeader.includes("item code") || normHeader === "icode" || normHeader === "itemcode") {
                            matchedKey = "itemCode";
                        } else if (normHeader.includes("set barcode") || normHeader === "barcode" || normHeader === "setbarcode") {
                            matchedKey = "setBarCode";
                        } else if (normHeader.includes("length")) {
                            matchedKey = "length";
                        } else if (normHeader.includes("breadth")) {
                            matchedKey = "breadth";
                        } else if (normHeader.includes("height")) {
                            matchedKey = "height";
                        } else if (normHeader.includes("weight")) {
                            matchedKey = "weight";
                        }
                    }

                    if (matchedKey) {
                        colIndexToKey[index] = matchedKey;
                    }
                });

                const isItemPo = isPoNonSet();
                const primaryIdKey = isItemPo ? "itemCode" : "setBarCode";

                let hasIdCol = Object.values(colIndexToKey).includes(primaryIdKey) || Object.values(colIndexToKey).includes("itemCode") || Object.values(colIndexToKey).includes("setBarCode");
                let hasQtyCol = Object.values(colIndexToKey).includes("newRequestedQty");

                if (!hasIdCol || !hasQtyCol) {
                    customToast({
                        title: "Excel Format Error",
                        description: `The uploaded Excel file must contain '${headersObject[primaryIdKey] || (isItemPo ? "Item Code" : "Set Barcode")}' and '${headersObject["newRequestedQty"] || "Request Qty"}' columns.`,
                        status: "error",
                    });
                    return;
                }

                let poDetailsData = [...poDetails];

                dataRows.forEach(row => {
                    let rowData = {};
                    row.forEach((cellVal, colIdx) => {
                        let key = colIndexToKey[colIdx];
                        if (key) {
                            rowData[key] = cellVal;
                        }
                    });

                    let idVal = rowData[primaryIdKey] || rowData["itemCode"] || rowData["setBarCode"];
                    let reqQtyVal = rowData["newRequestedQty"];

                    if (idVal !== undefined && idVal !== null && reqQtyVal !== undefined && reqQtyVal !== null) {
                        let index = poDetailsData.findIndex(item => 
                            String(item[primaryIdKey]) === String(idVal) ||
                            String(item.itemCode) === String(idVal) ||
                            String(item.setBarCode) === String(idVal) ||
                            String(item.id) === String(idVal)
                        );

                        if (index !== -1) {
                            let value = String(reqQtyVal).trim();
                            let item = poDetailsData[index];
                            let result = !Number.isNaN(value) && item.qtyInputType ? item.qtyInputType === "I" ? allowOnlyNumbers(value) : uptoTwoDecimalRegex(value) : true;
                            if (result) {
                                poDetailsData[index].newRequestedQty = +value;
                                poDetailsData[index].setPendingQty = parseFloat((poDetailsData[index].availableQty - poDetailsData[index].newRequestedQty).toFixed(2));
                                poDetailsData[index].newCancelledQty = 0;
                                
                                if (Number(value) > getRowAvailableQtyBasedOnTolerancePer(poDetailsData[index])) {
                                    poDetailsData[index].maxQtyError = `Request Qty must not exceed ${getRowAvailableQtyBasedOnTolerancePer(poDetailsData[index])}`;
                                } else {
                                    poDetailsData[index].maxQtyError = "";
                                }
                            }

                            // Optional LBH and weight fields if present in Excel
                            if (rowData.length !== undefined && rowData.length !== null) poDetailsData[index].length = rowData.length;
                            if (rowData.breadth !== undefined && rowData.breadth !== null) poDetailsData[index].breadth = rowData.breadth;
                            if (rowData.height !== undefined && rowData.height !== null) poDetailsData[index].height = rowData.height;
                            if (rowData.weight !== undefined && rowData.weight !== null) poDetailsData[index].weight = rowData.weight;
                        }
                    }
                });

                let overallRequestedQty = 0, overallAvailableQty = 0, overallOrderPercentage = 0;
                poDetailsData.forEach((item, index) => {
                    if (item.newRequestedQty > 0) {
                        overallAvailableQty += item.availableQty;
                        overallRequestedQty += +item.newRequestedQty;
                    }
                    
                    let rowPerValue = (Number(item.newRequestedQty) / item.availableQty) * 100;
                    if (item.newRequestedQty && item.consumptionConfigValue && rowPerValue < Number(item.consumptionConfigValue)) {
                        item.minQtyError = `Request Qty must be at least ${item.consumptionConfigValue}% of ${item.availableQty}`;
                    } else if (item.consumptionConfigValue && item.minQtyError) {
                        item.minQtyError = "";
                    }
                });

                overallOrderPercentage = overallAvailableQty > 0 ? (overallRequestedQty / overallAvailableQty) * 100 : 0;
                let overallRequestedQtyError = "";
                if (vendConfig?.asnCreationFulfilmentRequired?.toLowerCase() === "true") {
                    if (vendConfig?.cancelLinePendingQty?.toLowerCase() === "true") {
                        if (overallOrderPercentage < Number(vendConfig?.asnCreationFulfilment)) {
                            overallRequestedQtyError = `Total Request Qty must be at least ${vendConfig?.asnCreationFulfilment}% of ${overallAvailableQty}`;
                        } else {
                            overallRequestedQtyError = "";
                        }
                    }
                    poDetailsData.forEach(item => {
                        if (Number(item.availableQty) > 0 && Number(item.newRequestedQty) > 0) {
                            let minRequiredPercentage = Math.max(
                                Number(item.consumptionConfigValue || 0),
                                Number(vendConfig?.asnCreationFulfilment || 0)
                            );
                            const orderPercentage = (Number(item.newRequestedQty) / item.availableQty) * 100;
                            if (orderPercentage < minRequiredPercentage) {
                                item.minQtyError = `Request Qty must be at least ${minRequiredPercentage}% of ${item.availableQty}`;
                            } else {
                                item.minQtyError = "";
                            }
                        } else {
                            item.minQtyError = "";
                        }
                    });
                } else {
                    if (!overallRequestedQty) {
                        overallRequestedQtyError = "Total Request Qty cannot be 0";
                    } else {
                        overallRequestedQtyError = "";
                    }
                }

                setPoDetails(poDetailsData);
                setOriginalPoDetails(poDetailsData);
                setState(prevState => ({
                    ...prevState,
                    overallRequestedQtyError: overallRequestedQtyError
                }));
                checkAsnAmount(poDetailsData);

                customToast({
                    title: "Success",
                    description: `Excel data processed successfully.`,
                    status: "success",
                });
                
                setOpenedModal(false);

            } catch (e) {
                console.log("Excel Read Error", e);
                customToast({
                    title: "Excel Read Error",
                    description: `Failed to read the Excel file.`,
                    status: "error",
                });
            }
        }
    };

    const getChildComponent = () => {
        switch (openedModal) {
            case "uploadAsnExcel": return FileUpload;
            default: return React.Fragment;
        }
    }

    const getParentChildProps = () => {
        const isMobile = typeof window !== 'undefined' && window.innerWidth < 768;
        let payload = {
            animationType: "bottom",
            parentModalOuterMostClassName: 'flex items-center justify-center p-3 md:p-0',
            postitionProps: { position: 'relative' },
            dimensions: {
                width: isMobile ? "94vw" : "60vw",
                height: isMobile ? "75vh" : "75vh",
                maxHeight: isMobile ? "650px" : "800px",
                maxWidth: "850px",
                borderRadius: "8px"
            },
            closeModal: () => setOpenedModal(false),
        }
        switch (openedModal) {
            case "uploadAsnExcel": {
                return {
                    ...payload,
                    parentModalMainClass: '!w-[94vw] md:!w-[60vw] !max-w-[850px] !h-[75vh] !max-h-[650px] md:!max-h-[800px] rounded-[8px] overflow-hidden',
                    dimensions: {
                        width: isMobile ? "94vw" : "60vw",
                        height: isMobile ? "75vh" : "75vh",
                        maxHeight: isMobile ? "650px" : "800px",
                        maxWidth: '850px',
                        borderRadius: '6px'
                    },
                    heading: "Upload ASN Excel",
                    filesSupprotedHeading: "XLS, XLSX",
                    filesSupportedValidationArray: ["xls", "xlsx"],
                    downloadSampleCustomFunction: () => {
                        exportExcelForThisPo()
                    },
                    submitFile: (config) => {
                        uploadAsnExcel(config);
                    },
                    finalSubmitButtonLoading : false,
                    downloadSampleButtonLoading : isExportingExcel,
                    downloadSampleButtonLabel: isPoNonSet() ? "Download PO Item Details" : "Download PO Set Details",
                }
            }
        }
    }

    return (
        <div className='create-asn-modal'>
            {openedModal && (
                <ParentModal
                    childComponent={getChildComponent()}
                    getParentChildProps={getParentChildProps()}
                />
            )}
            <GenericFormSpreadTypeComponent
                spreadFormExtraClass="pb-[80px] md:pb-0"
                headerComponent={{
                    headerClassName: "!h-auto md:!h-[65px] !flex justify-between items-center",
                    rightContainerClassname: "!hidden",
                    label: () => {
                        return <div className='flex items-center gap-2 md:gap-7 flex-col md:flex-row'>
                            <div className='mhs-left'>
                                <h4 className='whitespace-nowrap'>{"Create Shipment With LR"}</h4>
                            </div>
                            <div className='mhs-left flex items-center flex-col md:flex-row md:gap-3 '>
                                <GenericInput
                                    genInputExtraClass="!w-[175px] !m-0 !hidden md:!block"
                                    gibInnerClassName="!border-[#A9A8A8]"
                                    key="orderNumber"
                                    value={selectedData?.orderNumber}
                                    type={"dropdown"}
                                    inputProps={() => getInputProps("getPoDetails")}
                                    onChange={(data) => handleChange("discardDraftedASN", data)}
                                    iconRight={
                                        <div className="border-l border-[#A9A8A8] flex items-center h-[31px] !-my-3 pl-2 ml-1">
                                            <Icons.DownArrowNew />
                                        </div>
                                    }
                                />
                                <div className='mhsl-row'>
                                    <div className='ksmhl-col'>
                                        <p><LanguageTranslator>ASN Number</LanguageTranslator></p>
                                        <h3>{selectedData?.asnMask || "-"}</h3>
                                    </div>
                                </div>
                            </div>
                        </div>
                    },
                    rightComponent: () => {
                        return (
                            <div className='flex items-center gap-2'>
                                <GenericCustomButton
                                    type='primary'
                                    label="Login"
                                    onClick={() => window.open("https://procure.rsbrothers.net", "_blank")}
                                    className='!h-[32px] !px-4 !text-xs !font-medium !rounded-[5px]'
                                    // leftIcon={<Icons.UserIcon />}
                                />
                            </div>
                        )
                    }
                }}

                inputState={formData}
                updateInputState={setFormData}
                errorState={errorData}
                updateErrorState={setErrorData}

                inputSections={{
                    lrDetails: {
                        label: "LR Details",
                        inputFields: () => getInputFields("lrDetails"),
                    },
                    shipmentDetails: {
                        label: "Shipment Details",
                        inputFields: () => getInputs(),
                        bottomComponent: formBottomExtras()
                    }
                }}

                availableDocument={props.availableDocument || null}
                spreadFormFotterExtraClass="absolute bottom-0 right-0 bg-white w-full z-[9] md:relative md:bottom-auto md:right-auto"

                finalSubmit={(data) => handleSubmit("finalSubmit", data)}
                finalSubmitButton={"Submit"}
                finalButtonDisabled={() => digiVendStore?.createShipmentWithLrData?.isLoading || Object.keys(errorData || {})?.length == 0}
                finalSubmitButtonTooltip={(vendConfig?.INVOICE_UPLOAD_AT_CREATE_ASN?.toLowerCase() == "true" && vendConfig?.VALIDATE_INV_AND_ASN_AMT?.toLowerCase() == "restrict") ? (+(vendConfig?.INV_AMT_TOLERANCE_AT_CREATE_ASN) && vendConfig?.INV_AMT_TOLERANCE_TYPE?.toLowerCase() !== "disable") ? setInvoiceAmountRange() : Number(showCheckAmount(poDetails)) != Number(formData?.shipmentDetails?.["invoiceAmount"] || "") ? `Invoice amount is not equal to  ASN amount i.e. ${showCheckAmount(poDetails)} for Requested Quantity` : "" : null}
            />
        </div>
    )
}

export default CreateShipmentWithLr